import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import endpoints from '../../config/endpoints';
import { Sidebar } from '../../layouts/Sidebar';
import { setLoading } from '../../services/reducers/homeSlice';
import restApi from '../../services/restApi';
import RichTextEditor, {
  EDITOR_UPLOAD_PENDING_MESSAGE,
  editorUploadsPending,
} from '../../components/RichTextEditor';
import tools from '../../utils/tools';

const PageManage = () => {
  const { id: paramId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form, setForm] = useState<any>({});
  const [image, setImage] = useState<any>({});

  const send = async () => {
    // an editor image still uploading would be saved without its address
    if (editorUploadsPending()) {
      Swal.fire({
        title: "صبر کنید",
        text: EDITOR_UPLOAD_PENDING_MESSAGE,
        icon: "warning",
        confirmButtonText: "متوجه شدم",
      });
      return;
    }
    dispatch(setLoading(true));

    const res = await restApi(endpoints.page.basic + (paramId || '')).post(tools.extractor(form, ['title', 'content']));

      if (res.code == 200) {
        Swal.fire({
          title: 'موفق',
          text: `صفحه با موفقیت ${paramId ? 'ویرایش' : 'ایجاد'} شد`,
          icon: 'success',
          confirmButtonText: 'متوجه شدم',
          didClose() {
            navigate('/page')
          }
        });
      } else {
        Swal.fire({
          title: 'ناموفق',
          text: res?.data,
          icon: 'error',
          confirmButtonText: 'متوجه شدم'
        });
      }

    dispatch(setLoading(false));
  };

  const fetchItem = async () => {
    dispatch(setLoading(true));

    const res = await restApi(endpoints.page.single + paramId, true).get();

    if (res.code == 200) {
      setForm({
        title: res.data?.title,
        content: res.data?.content
      });
      setImage({
        data: undefined,
        preview: res.data.media?.url
      })
    }

    dispatch(setLoading(false));
  };

  useEffect(() => {
    paramId && fetchItem();
  }, []);

  return (
    <>
      <body className="dashboardBody">
      <Sidebar/>
      <main className="dashBoardMain main">
        <div className="addInfoHeader">
          <span className="dashboardHeader keepRight clickable" onClick={send}>
           {paramId ? 'ویرایش ' : 'ایجاد '}صفحه
          </span>
          <span>
            <h1 className="sideBarTitle">بازگشت به لیست صفحه</h1>
             <h1 className="dashBoardTitle">{paramId ? 'ویرایش' : 'ایجاد'} صفحه </h1>
          </span>
          <i className="backAdd clickable" onClick={() => navigate('/page/')}></i>
        </div>
        <section className="bottomSection">
          <h1 className="dashBoardTitle">اطلاعات صفحه</h1>
          <form className="addInfo">
            <label className="sideBarTitle" htmlFor="infoTitle">عنوان</label>
            <input className="addInput" id="infoTitle" onChange={(input: any) => setForm(prev => ({
              ...prev,
              title: input.target.value
            }))} value={form.title}/>
            <label className="sideBarTitle">محتوا</label>
            <RichTextEditor
              value={form.content}
              onChange={(content) => setForm((prev) => ({ ...prev, content }))}
            />
          </form>
        </section>
      </main>
      </body>
    </>
  );
};
export default PageManage;